<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="6" style="text-align: left">
        <router-link to="/team">
          <img src="../images/common/backArrow.png" class="imageback"
        /></router-link>
      </van-col>
      <van-col span="18" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700"
          >{{ $t("directDownline.topic") }}</span
        >
      </van-col>
    </van-row>
    <!-- --------------------- active item ---------------- -->
    <!-- <van-row style="padding: 10px">
      <van-row class="downlineBox_active">
        <van-row class="downlineRow">
          <van-col span="12">
            <div class="rightInfo">
              <img
                src="../images/common/name_active.png"
                style="width: 20px"
              /><span class="lineList_active">{{ $t("directDownline.name") }}</span>
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo_active">Jonsa</span>
          </van-col>
        </van-row>
        <van-row class="downlineRow" style="padding-top: 25px">
          <van-col span="12">
            <div class="rightInfo">
              <img
                src="../images/common/telephone_active.png"
                style="width: 20px"
              /><span class="lineList_active">{{ $t("directDownline.telephone") }}</span>
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo_active">1567554667</span>
          </van-col>
        </van-row>
        <van-row class="downlineRow" style="padding-top: 25px">
          <van-col span="12">
            <div class="rightInfo">
              <img
                src="../images/common/investment_active.png"
                style="width: 20px"
              /><span class="lineList_active">{{ $t("directDownline.totalInvestment") }}</span>
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo_active">$453454.00</span>
          </van-col>
        </van-row>
      </van-row>
    </van-row> -->
    <!-- --------------------- in-active item ---------------- -->
    <van-row style="padding: 10px" v-for="item in data" :key="item.id">
      <van-row class="downlineBox">
        <van-row class="downlineRow">
          <van-col span="12">
            <div class="rightInfo">
              <img src="../images/common/name.png" style="width: 20px" /><span
                class="lineList"
                >{{ $t("directDownline.name") }}</span
              >
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo">{{item.nickname}}</span>
          </van-col>
        </van-row>
        <van-row class="downlineRow" style="padding-top: 25px">
          <van-col span="12">
            <div class="rightInfo">
              <img
                src="../images/common/telephone.png"
                style="width: 20px"
              /><span class="lineList">{{ $t("directDownline.telephone") }}</span>
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo">{{item.mobile}}</span>
          </van-col>
        </van-row>
        <van-row class="downlineRow" style="padding-top: 25px">
          <van-col span="12">
            <div class="rightInfo">
              <img
                src="../images/common/investment.png"
                style="width: 20px"
              /><span class="lineList">{{ $t("directDownline.totalInvestment") }}</span>
            </div>
          </van-col>
          <van-col span="12" style="text-align: right">
            <span class="lineInfo">${{item.user_account.totalinvest}}</span>
          </van-col>
        </van-row>
      </van-row>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row } from "vant";
import Fetch from "../../utils/fetch";
Vue.use(Icon).use(Row).use(Col);

export default {
  name: "teamdirectdownline",
  components: {
    Header,
  },
  data() {
    return {
      data:[]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      Fetch("/agent_account/listDirectDownline").then((res)=>{
        if(res.code == 1){
          this.data = res.data;
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 40px;
  width: auto;
}

.downlineBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 20px 15px;
  background: #ebebeb29;
}

.downlineBox_active {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border-radius: 13px;
  padding: 20px 15px;
  background-image: linear-gradient(#f2d627, #e29218);
}

.logoutBg {
  background: url(../images/member/logoutBtnBg.png);
  background-size: 100% 100%;
}

.logoutText {
  color: #000000;
  font-size: 22px;
  text-align: center;
  padding: 12px 0px;
}

.lineList {
  font-size: 17px;
  color: #ebedf0;
  padding-left: 10px;
}

.lineInfo {
  font-size: 17px;
  color: #ffffff;
  padding-left: 10px;
}

.lineList_active {
  font-size: 17px;
  color: #000000;
  padding-left: 10px;
}

.lineInfo_active {
  font-size: 17px;
  color: #000000;
  padding-left: 10px;
}

.rightInfo {
  display: flex;
  align-items: center;
}

.linktext {
  position: absolute;
  right: 20px;
}

.linkIcon {
  color: #ebedf0;
  font-size: 18px;
}

.downlineRow {
  display: flex;
  align-items: center;
}
</style>
